import { useEffect } from "react";
import { Record } from "../Models/Record";
import Person, { Event, Relationship } from "../Models/Person";
import NumidentHint from "../Models/NumidentHint";
import { Tree } from "../Models/Tree";

export default function useFormatData({
  data,
  setRecord,
  setTree,
}: {
  data: (NumidentHint | Error)[];
  setRecord: Function;
  setTree: Function;
}) {
  useEffect(() => {
    if (!data || data.length < 1) return;
    if (typeof data === "string") return;

    const firstHint = data[0];
    if (firstHint instanceof Error) return;
    setRecord(
      new Record({
        ARK: firstHint.ark,
        title: firstHint.batchID,
        people: [
          new Person({
            firstname: firstHint.givenname,
            firstnameUnique: firstHint.pr_name_gn_unique,
            lastname: firstHint.surname,
            lastnameUnique: firstHint.pr_name_surn_unique,
            birth: new Event({
              type: "birth",
              location: firstHint.birthplace,
              ...dateToEventDate(firstHint.birthdate),
            }),
            death: new Event({
              type: "death",
              ...dateToEventDate(firstHint.deathdate),
            }),
            relationship: Relationship.FocusPerson,
          }),
          new Person({
            firstname: firstHint.father_givenname,
            firstnameUnique: firstHint.pr_fthr_name_gn_unique,
            lastname: firstHint.father_surname,
            lastnameUnique: firstHint.pr_fthr_name_surn_unique,
            sex: "Male",
            relationship: Relationship.Father,
          }),
          new Person({
            firstname: firstHint.mother_givenname,
            firstnameUnique: firstHint.pr_mthr_name_gn_unique,
            lastname: firstHint.mother_surname,
            lastnameUnique: firstHint.pr_mthr_name_surn_unique,
            sex: "Female",
            relationship: Relationship.Mother,
          }),
        ],
      })
    );
    setTree(
      new Tree({
        PID: firstHint.pid,
        people: [
          new Person({
            firstname: firstHint.pr_name_gn,
            lastname: firstHint.pr_name_surn,
            birth: new Event({
              type: "birth",
              location: firstHint.pr_bir_place,
              ...dateToEventDate(firstHint.pr_bir_date),
            }),
            death: new Event({
              type: "death",
              ...dateToEventDate(firstHint.pr_dea_date),
            }),
            relationship: Relationship.FocusPerson,
          }),
          new Person({
            firstname: firstHint.pr_fthr_name_gn,
            lastname: firstHint.pr_fthr_name_surn,
            sex: "Male",
            relationship: Relationship.Father,
          }),
          new Person({
            firstname: firstHint.pr_mthr_name_gn,
            lastname: firstHint.pr_mthr_name_surn,
            sex: "Female",
            relationship: Relationship.Mother,
          }),
        ],
      })
    );

    function dateToEventDate(date: string) {
      const _date = new Date(date);
      if (!_date.valueOf()) return undefined;
      return {
        day: _date.getUTCDate(),
        month: _date.toLocaleString("default", { month: "long" }),
        year: _date.getUTCFullYear(),
      };
    }
  }, [data, setRecord, setTree]);
}
